<app-header [breadcrumbs]="['Clients', 'Add Client']" mainHeading="Add Client" [links]="['/clients', '/add-client']" />

<form>
    <main class="add-new-shell">
        @if (createClientRequest.error(); as error) {
            <app-error-panel [error]="error" class="error-panel-margin" />
        }
        <cll-card class="add-new-card">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">person</cll-icon>
                <cll-card-title>Details</cll-card-title>
            </cll-card-header>

            <div class="add-new-row-container">
                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Reference" class="w-full">
                            <input cllFormInput type="text" [formControl]="clientDetailsFormGroup.controls.reference">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="NHS number" class="w-full">
                            <input cllFormInput type="text" [formControl]="clientDetailsFormGroup.controls.nhs_number">
                        </cll-form-field>
                    </div>
                </div>
            </div>
        </cll-card>

        <cll-card class="add-new-card">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">person</cll-icon>
                <cll-card-title>Profile</cll-card-title>
            </cll-card-header>

            <div class="add-new-row-container">
                <div class="grid-columns-3-small">
                    <div>
                        <cll-form-field label="Title" class="small-input">
                            <input cllFormInput [formControl]="personDetailsFormGroup.controls.title" type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Given name" class="w-full">
                            <input cllFormInput [formControl]="personDetailsFormGroup.controls.given_name" type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Family name" class="w-full">
                            <input cllFormInput [formControl]="personDetailsFormGroup.controls.family_name" type="text">
                        </cll-form-field>
                    </div>
                </div>
                <div>
                    <cll-form-field label="Middle names" class="w-full">
                        <input cllFormInput [formControl]="personDetailsFormGroup.controls.middle_names" type="text">
                    </cll-form-field>
                </div>

                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Preferred name" class="w-full">
                            <input cllFormInput [formControl]="personDetailsFormGroup.controls.preferred_name"
                                   type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Pronouns" class="w-full">
                            <input cllFormInput [formControl]="personDetailsFormGroup.controls.pronouns" type="text">
                        </cll-form-field>
                    </div>
                </div>

                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Date of birth" class="w-full">
                            <input cllFormInput [formControl]="personDetailsFormGroup.controls.date_of_birth"
                                   type="date">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Birth sex" class="w-full">
                            <select cllFormInput [formControl]="personDetailsFormGroup.controls.birth_sex">
                                <option value=""></option>
                                <option value="m">Male</option>
                                <option value="f">Female</option>
                                <option value="o">Indeterminate</option>
                            </select>
                        </cll-form-field>
                    </div>
                </div>
            </div>
        </cll-card>

        <cll-card class="add-new-card">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">account_circle</cll-icon>
                <cll-card-title>Contact & access details</cll-card-title>
            </cll-card-header>

            <div class="add-new-row-container">
                <div class="phone-numbers-container">
                    <span>Phone number</span>
                    <form [formGroup]="contactNumbersForm">
                        <div formArrayName="contactNumbers">
                            <div *ngFor="let contactNumberFormGroup of contactNumbersFormArray.controls; let i = index"
                                 [formGroupName]="i">
                                <div class="contact-numbers-container">
                                    <div>
                                        <cll-form-field label="Contact type">
                                            <select formControlName="type" cllFormInput>
                                                <option value="mobile">Mobile</option>
                                                <option value="landline">Landline</option>
                                                <option value="work">Work</option>
                                                <option value="fax">Fax</option>
                                            </select>
                                        </cll-form-field>
                                    </div>
                                    <div>
                                        <cll-form-field label="Contact number">
                                            <input cllFormInput formControlName="number" type="text">
                                        </cll-form-field>
                                    </div>
                                    <div>
                                        <button cll-button class="delete-button" type="button"
                                                (click)="removeContactNumber(i)">
                                            <cll-icon type="outlined" [size]="24">delete</cll-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button cll-outline-button class="add-button" (click)="addContactNumber()">
                            <cll-icon cllButtonIcon>add</cll-icon>
                            Add
                        </button>
                    </form>
                </div>
                <span class="add-new-field-group-label">Address</span>
                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Address line 1" class="w-full">
                            <input cllFormInput type="text" [formControl]="addressFormGroup.controls.street_1">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Address line 2" class="w-full">
                            <input cllFormInput type="text" [formControl]="addressFormGroup.controls.street_2">
                        </cll-form-field>
                    </div>
                </div>

                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Town/City" class="w-full">
                            <input cllFormInput type="text" [formControl]="addressFormGroup.controls.town">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="County" class="w-full">
                            <input cllFormInput type="text" [formControl]="addressFormGroup.controls.county">
                        </cll-form-field>
                    </div>
                </div>

                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Postcode" class="w-full">
                            <input cllFormInput type="text" [formControl]="addressFormGroup.controls.post_code">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Country" class="w-full">
                            <input cllFormInput type="text" [formControl]="addressFormGroup.controls.country">
                        </cll-form-field>
                    </div>
                </div>

                <span class="add-new-field-group-label">Address additional comments</span>
                <div>
                    <div>
                        <cll-form-field label="Address additional comments" class="w-full">
                            <input cllFormInput type="text" placeholder="e.g. What3Words location"
                                   [formControl]="addressFormGroup.controls.additional_comments">
                        </cll-form-field>
                    </div>
                </div>

                <hr class="add-new-divider">
                <div class="grid-columns-2">
                    <cll-slide-toggle
                        class="p-0"
                        [colour]="'secondary'"
                        [formControl]="addressFormGroup.controls.hard_to_reach"
                        >Is the property hard to reach?</cll-slide-toggle
                    >
                </div>

            </div>
        </cll-card>

        <cll-card class="add-new-card">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">chat</cll-icon>
                <cll-card-title>Additional comments</cll-card-title>
            </cll-card-header>

            <div class="add-new-row-container">
                <div>
                    <cll-form-field label="" class="w-full">
                        <textarea cllFormInput
                                  [formControl]="personDetailsFormGroup.controls.additional_comments"></textarea>
                    </cll-form-field>
                </div>
            </div>
        </cll-card>

        <cll-card>
            <div class="add-new-footer-buttons-container">

                <button cll-button (click)="cancel()">
                    Cancel
                </button>
                <button cll-outline-button (click)="reset()" [disabled]="!dirtyFormCheck">
                    Reset
                </button>
                <button cll-filled-button colour="secondary" (click)="add()">
                    <cll-icon cllButtonIcon>check</cll-icon>
                    Create client
                </button>
            </div>
        </cll-card>

    </main>
</form>
